import React, { useCallback } from 'react';
import { Link } from '@ontruck/orc';
import { openShipper } from 'redux/modules/job-detail/effects';
import { useDispatch } from 'react-redux';

const ShipperName = ({ name, shipperId }) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(openShipper({ shipper_id: shipperId }));
  }, [dispatch, shipperId]);

  return <Link text={name} weight="bold" onClick={handleClick} />;
};

export default ShipperName;
